import { apiRequest } from "../services/apiRequest"

export const organizationApi = {
  getOverview: async () =>
    await apiRequest("get", "/account/organization/", undefined, { skipCache: true }),

  getMembers: async () =>
    await apiRequest("get", "/account/organization/members/", undefined, {
      skipCache: true,
    }),

  addMember: async (data) =>
    await apiRequest("post", "/account/organization/members/", data),

  allocateMember: async (memberId, data) =>
    await apiRequest(
      "post",
      `/account/organization/members/${memberId}/allocate/`,
      data,
    ),

  reclaimMember: async (memberId, data = {}) =>
    await apiRequest(
      "post",
      `/account/organization/members/${memberId}/reclaim/`,
      data,
    ),

  getGenerations: async (params = {}) => {
    const search = new URLSearchParams()
    if (params.page) search.append("page", params.page)
    if (params.page_size) search.append("page_size", params.page_size)
    if (params.feature) search.append("feature", params.feature)
    if (params.dashboard_user_id) {
      search.append("dashboard_user_id", params.dashboard_user_id)
    }
    const qs = search.toString()
    const url = `/account/organization/generations/${qs ? `?${qs}` : ""}`
    return await apiRequest("get", url, undefined, { skipCache: true })
  },
}
